import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ReactiveFormsModule, FormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { RefundService, ToastMessageService } from '@fitness-force/api';
import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import { DataGridComponent, EmptyStateContainerComponent } from '@fitness-force/grid';
import { DateFormatedComponent } from '@fitness-force/grid-utility';
import { ActionsComponent } from '@fitness-force/grid-utility/action';
import { CurrencyComponent } from '@fitness-force/grid-utility/currency';
import { Claim, TENANTSINTERFACE, voidSalesReturnRequest, Refund, RefundList, PdfType } from '@fitness-force/models';
import { NumberPrefixComponent } from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { BehaviorSubject, Observable } from 'rxjs';
import { RefundStatusComponent } from '../refund-status/refund-status.component';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'refund-tab',
  templateUrl: './refund-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    DividerModule,
    TimelineModule,
    TableModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    SelectModule,
    AvatarModule,
    TagModule,
    StyleClassModule,
    DialogModule,
    PdfViewerModule,
    PopoverModule,
    DataGridComponent,
    ErrorMsgComponent,
    SkeletonModule,
    TranslateModule],
})
export class RefundListComponent implements OnInit {

  @Input('clientId') clientId = 0;
  @Input('tenantId') tenantId = 0;
  @Input('subscriptionId') subscriptionId = 0;
  @Input('showTableActions') showTableActions = true;
  @Input('showHeader') showHeader = true;

  RefundData$ = new BehaviorSubject<Refund[]>([] as Refund[]);
  RefundTablecolumns$ = new BehaviorSubject<any>([]);
  RefundClientDataObject: BehaviorSubject<Refund> | any;
  selectallRefundData = false;

  claim$: Observable<Claim[]> = new Observable();
  _filterStaff = new BehaviorSubject<number[]>([0]);
  _sessionOwner = new BehaviorSubject<number[]>([0]);
  accessedTenants:any;
  btnLoading=false;
  emptyStateComponent$ = new BehaviorSubject<any>(EmptyStateContainerComponent);
  showBulkActionBar: boolean=false;
  RefundId:number=0;
  RefundDetails:Refund;
  showRefundVoid:boolean=false;
  voidRefundForm: UntypedFormGroup = new UntypedFormGroup({});
  number_prefix:string="";
  showInvoicePopup:boolean=false;

  showRefundPopup = new BehaviorSubject(false);
  pdfSrc = new BehaviorSubject<string>('');
  loading:boolean = false;


  constructor(  private store: Store,
    private translate: TranslateService,
    private toastMessageService: ToastMessageService,
    private fb: UntypedFormBuilder,
    private refundService:RefundService,
    private toastService:ToastMessageService, 
    private cd: ChangeDetectorRef
     ) { }

  ngOnInit(): void {
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.accessedTenants = tenant.accessed_tenant;
    });
    this.getRefund();
  }

  ngAfterViewInit() {
    this.voidRefundForm = this.fb.group({
      void_reason: ['', [Validators.required]],
    });
  }

  getRefund() {
    this.loading = true;
    this.refundService.getRefund(this.clientId).subscribe({
      next: (data: RefundList) => {
        this.setClientRefunds(data.items ? data.items : []);
        this.loading = false;
      },
      error: (error: AppErrors) => {
        this.setClientRefunds([]);
        this.loading = false;
      },
    });
  }

  setClientRefunds(Refunds: Refund[]) {
    this.RefundData$.next(Refunds);
    this.selectallRefundData = false;
    this.GetRefundTableColumns();
  }

  GetRefundTableColumns() {
    this.translate
      .get([
        'REFUND.COLUMNS.DATE',
        'REFUND.COLUMNS.ID',
        'REFUND.COLUMNS.PAYMENT',
        'REFUND.COLUMNS.REFUND_AMOUNT',
        'REFUND.COLUMNS.STATUS'
  ])
      .subscribe((translations) => {
        this.ColumnsInvoiceTableTransalation(translations);
      });
  }

  ColumnsInvoiceTableTransalation(translations: any) {
    let Columns = {
      DATE: translations['REFUND.COLUMNS.DATE'],
      PAYMENT: translations[ 'REFUND.COLUMNS.PAYMENT'],
      ID: translations[ 'REFUND.COLUMNS.ID'],
      AMOUNT: translations['REFUND.COLUMNS.REFUND_AMOUNT'],
      STATUS: translations['REFUND.COLUMNS.STATUS']
    };

    this.RefundTablecolumns$.next([
      {
        title: Columns.DATE,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'refund_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'refund_date', format: 'd MMM y' },
        },
      },
      {
        title: Columns.ID,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'refund_prefix',
        type: 'component',
        data: {  
          name: NumberPrefixComponent,
          additionData: true,
          aData: { fetch_key: 'refund_prefix', type: PdfType.Refund,id:'id' }
        },
      },
      {
        title: Columns.PAYMENT,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'payment_prefix',
        type: 'component',
        data: {  
          name: NumberPrefixComponent,
          additionData: true,
          aData: { fetch_key: 'payment_prefix', type: PdfType.Payment,id:'payment_id', status:'payment_status' }
        },
      },
      {
        title: Columns.AMOUNT,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'amount_in_minor_currency',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'amount_in_minor_currency',
        },
      },
      {
        title: Columns.STATUS,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'refund_status',
        type: 'component',
        data: {
          name: RefundStatusComponent,
          additionData: true,
          aData: { fetch_key: 'refund_status' },
        }
      }
    ]);

    if (this.showTableActions) {
      this.RefundTablecolumns$.value.push({
        title: '',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'actions',
        type: 'component',
        data: {
          name: ActionsComponent,
          additionData: true,
          aData: [
            'refundvoid',
            'sendemail',
            'print'
          ],
        },
      });
    }
  }

  handleSelectAll(selection: any) {
    if (selection.checked) {
      this.showBulkActionBar = true;
    } else {
      this.showBulkActionBar = false;
    }
  }

  handleEvent(e: any) {}

  handleTabAction(event:{closePopup:boolean, reloadData:boolean})
  {
    console.log(event);
  }

  onActionEvent(event: any) {
    switch (event.action) {
      case 'refundvoid':
        {
          this.RefundId = event.columnData.id;
          this.RefundDetails = event.columnData;
          this.showRefundVoid=true;
        }
       break;
      case 'sendemail':
        {
          this.RefundDetails = event.columnData;
          this.SendRefundPdf(false).then((res) => {
          });
        }
        break;
      case 'print':
        {
          this.RefundId = event.columnData.id;
          this.RefundDetails = event.columnData;
          this.GetRefundPdf(false).then((res) => {
            this.printInvoice();
          });
        }
        break;
  }
  }


  GetRefundPdf(showRefund: boolean) {
    let promise: Promise<boolean> = new Promise((resolve, reject) => {
      this.refundService.GetRefundPrint(this.clientId,this.RefundDetails.id)
        .subscribe({
          next: (data: any) => {
            this.pdfSrc.next(data.url);
            resolve(true);
          },
          error: (error: AppErrors) => {
              this.ShowToastErrors(error);
              resolve(false);
          },
        });
    });
    return promise;
  }

  SendRefundPdf(showRefund: boolean) {
    let promise: Promise<boolean> = new Promise((resolve, reject) => {
      let channels:any[]=[];
      channels.push("Email");
      this.refundService.SendRefundPdf(this.clientId,this.RefundDetails.id,channels)
        .subscribe({
          next: (data: any) => {
            this.pdfSrc.next(data);
            this.translate
            .get('TRANSACTION.MSG.INVOICE_MAIL_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
            resolve(true);
          },
          error: (error: AppErrors) => {
            if(error.originalError.status == 200)
            {
                this.toastMessageService.showSuccess(error.originalError.error.text);
                resolve(true);
            }
            else{
              this.ShowToastErrors(error);
              resolve(false);
            }
           
          },
        });
    });
    return promise;
  }

  printInvoice() {
    window.open(this.pdfSrc.value, '_blank');
  }

  deleteRefund(form: UntypedFormGroup) {
    this.btnLoading= true;
    if (form.valid) {
      let voidRequest: voidSalesReturnRequest = {} as voidSalesReturnRequest;
      voidRequest.void_reason = form.value.void_reason;
      let tenantId=0;
      if(this.accessedTenants.find((o: { id: number; }) => o.id == this.RefundDetails.tenant_id))
         tenantId =  this.RefundDetails.tenant_id;
      else tenantId= this.tenantId;
      this.refundService.VoidRefund(tenantId, this.clientId, this.RefundId, voidRequest)
        .subscribe({
          next: (data: any) => {
            this.translate
              .get('REFUND.MSG.REFUND_VOID_MSG')
              .subscribe((translation) => {
                this.toastService.showSuccess(translation);
              });
            this.voidRefundForm.reset();
            this.RefundDetails.refund_isvoid = true;
            let RefundData = this.RefundData$.value;
            RefundData.forEach((inv) => {
              if (inv.id == this.RefundDetails.id)
                inv.refund_isvoid  = true;
            });
            this.RefundData$.next(RefundData);
            this.GetRefundTableColumns();
            this.btnLoading= false;
            this.showRefundVoid = false;
            this.cd.detectChanges();
          },
          error: (error: AppErrors) => {
            this.btnLoading= false;
            this.toastService.showError(error);
            this.cd.detectChanges();
          },
        });
    } else {
      Object.keys(this.voidRefundForm.controls).forEach((field) => {
        const control = this.voidRefundForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      this.btnLoading= false;
    }
  }

  ShowToastErrors(error: any) {
   this.toastService.showError(error);
  }

  closeInvoicePopup(event:any)
  {
    this.showInvoicePopup=false;
  }

  closeRefundPopup()
  {
    this.showRefundPopup.next(false);
  }
  
  get VoidReasonFormControl(): UntypedFormControl {
    return this.voidRefundForm.controls['void_reason'] as UntypedFormControl;
  }


}
